import { render, staticRenderFns } from "./PGrid.vue?vue&type=template&id=44f1663f&scoped=true"
import script from "./PGrid.vue?vue&type=script&lang=js"
export * from "./PGrid.vue?vue&type=script&lang=js"
import style0 from "./PGrid.vue?vue&type=style&index=0&id=44f1663f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f1663f",
  null
  
)

export default component.exports